import EntityApi from "../Api/EntityApi";
import EntityType from "../Entities/Type/EntityType";
import EntityDefinitions from "../Entities/App/EntityDefinitions";

class MyPageService {

    constructor(jsonApi, state) {
        this.entityApi = new EntityApi(jsonApi);
        this.jsonApi = jsonApi;
        this.state = state;

        this.state.add('application', null);
        this.state.add('competition', null);
        this.state.add('errorMsg', '');
        this.state.add('loading', false);
        this.state.add('refMissing', true);
        this.state.add('lRef', '');
        this.state.add('saveRef', localStorage.getItem('frontend.longReference'));
    }

    getLongReference(lRef) {
        return lRef || sessionStorage.getItem('frontend.longReference') || localStorage.getItem('frontend.longReference');
    }

    fetchApplication(lRef) {
        let longReference = this.getLongReference(lRef);
        if (!longReference) {
            this.state.setRefMissing(true);
            return;
        }
        if (!longReference || this.state.loading) {
            return;
        }
        longReference = longReference.replace(/\s+/g, '');
        this.state.setLoading(true);
        this.state.setErrorMsg('');
        const path = 'admin/competition/mypagelogin.php?db='+sessionStorage.getItem('frontend.db')+'&code='+encodeURIComponent(longReference);
        this.jsonApi.get(path,
            (data) => {
                this.state.setLoading(false);
                const et = new EntityType(EntityDefinitions.getDefinition(data.data.type));
                this.updateData(et.createEntity(data.data.entity))
            },
            (res) => {
                if (res.status === 'unfound') {
                    this.updateData(null);
                }
                else {
                    this.state.setErrorMsg(res.message);
                }
                this.state.setLoading(false);
            });

    }

    updateData(app) {
        if (app) {
            this.state.setRefMissing(false);
            this.state.setApplication(app);
            this.state.setCompetition(app.runners[0].competitionClass.competition);
            this.saveLRef(true);
        }
        else {
            this.state.setErrorMsg('Ingen registrering hittad.');
        }
    }

    lrefGiven() {
        this.fetchApplication(this.state.lRef)
    }

    saveLRef(onlyIfRequested = false) {
        if (this.state.saveRef || !onlyIfRequested) {
            this.state.setSaveRef(true);
            localStorage.setItem('frontend.longReference', this.state.application.longReference)
        }
        else {
            sessionStorage.setItem('frontend.longReference', this.state.application.longReference)
        }

    }

    logOut() {
        localStorage.removeItem('frontend.longReference');
        sessionStorage.removeItem('frontend.longReference');
        window.location.href = './';
    }
}

export default MyPageService;